/**
 * 评论状态管理 vuex
 * created by song on 2018/1/3.
 */
import Api from "../api/bookReviewApi.js";

var state = {
  power: true, //  评论权限  默认无
  powerReqnum: 0, // 请求次数, 多组件不好监控, 只请求一次就好, 其他组件进行监听对应值
  detail: {}, // 详情信息
  user: {}, // 获取用户信息
  userReqnum: 0
};

var getters = {
  getPower: state => state.power,
  getDetail: state => state.detail,
  getUser: state => state.user
};

var actions = {
  // 查询权限接口
  queryPower({ commit, state }, params) {
    if (state.powerReqnum < 1) {
      Api.queryPower().then(res => {
        let datas = res.data;
        if (datas.status === 0 && datas.data && datas.data.value !== "0") {
          commit("setPower", true);
        }
      });
      commit("addNum", "powerReqnum");
    }
  },
  // 查询用户信息
  queryUser({ commit, state }, params) {
    if (state.userReqnum < 1) {
      Api.queryUser().then(res => {
        let datas = res.data;
        if(datas.result === '1' && datas.data){
          commit("setUser", datas.data);
        }
      });
      commit("addNum", "userReqnum");
    }
  }
};

var mutations = {
  addNum: (state, key) => state[key]++,
  setPower: (state, params) => (state.power = params),
  setDetail: (state, params) => (state.detail = params),
  setUser: (state, params) => (state.user = params)
};

export default {
  namespaced: true,
  name: "bookReview",
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/components/work/bookReview/common/module/bookReview_store.js